import Button from '@components/Button'
import { getScollerCSS } from '@components/Scroller/style'
import styled, { css } from 'styled-components'

export const DWrapper = styled.div`
  width: 267px;
  height: 100%;
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: block;
  }
`

export const MWrapper = styled.div`
  width: auto;
  display: none;
  position: relative;

  ${({ theme }) => css`
    @media (max-width: calc(${theme.breakpoints.xl} - 1px)) {
      display: grid;
      grid-gap: ${theme.space.sm};
      padding: ${theme.space.md};
      bottom: 0;
      left: 0;
      background: ${theme.colors.brandPrimaryContrast};
      box-shadow: 0 0 6px 0 rgb(0 0 0 / 50%);
    }
  `}
`

export const DContent = styled.div`
  height: 732px;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  ${({ theme }) => css`
    background-color: ${theme.colors.brandPrimaryContrast};
    border-radius: ${theme.radius.sm};
    padding: ${theme.space.md};
  `}
`

export const InfoWrapper = styled.span`
  ${({ theme }) => `
    svg {
      color: ${theme.palette.info100};
      font-size: 20px;
      cursor: pointer;
    }
  `}
`

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space.xs};
`

export const Title = styled.div`
  line-height: 1.22;
  letter-spacing: 0.63px;
  display: flex;
  align-items: center;

  ${({ theme }) => css`
    font-size: ${theme.fontSize.sm};
    font-weight: ${theme.fontWeight.bold};
    & > span {
      display: flex;
      margin-right: ${theme.space.xs};
    }
  `}
`

export const Footer = styled.div``
/*
    width: ${(disabled && mobile) || (!disabled && !mobile)
      ? `calc(100% - ${theme.space.sm} - ${theme.space.sm})`
      : '100%'};
    line-height: 1.14;
    letter-spacing: 0.49px;
    text-align: center;
    font-weight: ${theme.fontWeight.bold};
    background-color: ${disabled ? theme.palette.gray20 : theme.colors.brandPrimary};
    padding: ${mobile && !disabled ? theme.space.sm : theme.space.xxs} ${mobile && !disabled ? 0 : theme.space.sm}
      ${disabled ? theme.space.xs : theme.space.xs};
    color: ${disabled ? theme.palette.gray100 : theme.colors.brandPrimaryContrast};
    border-radius: ${theme.radius.sm};
    font-size: ${mobile ? theme.fontSize.xxs : '17px'};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    pointer-events: ${disabled ? 'none' : 'all'};
*/
export const Submit = styled.div<{ mobile?: boolean; disabled?: boolean; isBulkBook?: boolean }>`
  ${({ theme, mobile, disabled }) => css`
    width: 100%;
    line-height: 1.14;
    letter-spacing: 0.49px;
    text-align: center;
    font-weight: ${theme.fontWeight.bold};
    background-color: ${disabled ? theme.palette.gray20 : theme.colors.brandPrimary};
    padding: ${mobile ? theme.space.sm : theme.space.lg} 0;
    color: ${disabled ? theme.palette.gray100 : theme.colors.brandPrimaryContrast};
    border-radius: ${theme.radius.sm};
    font-size: ${mobile ? theme.fontSize.xxs : theme.fontSize.sm};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    pointer-events: ${disabled ? 'none' : 'all'};

    ${BulkBookButton} {
      svg {
        color: ${disabled ? theme.palette.gray100 : theme.colors.brandPrimaryContrast};
      }
    }
  `}

  ${({ theme, disabled, isBulkBook, mobile }) =>
    mobile &&
    isBulkBook &&
    css`
      width: ${disabled ? `calc(100% - ${theme.space.sm} - ${theme.space.sm})` : '100%'};
      font-size: ${theme.fontSize.xxs};
      font-stretch: normal;
      font-style: normal;
      padding: ${!disabled ? theme.space.sm : theme.space.xxs} ${!disabled ? 0 : theme.space.sm}
        ${disabled ? theme.space.xs : theme.space.xs};
    `}

  ${({ theme, disabled, isBulkBook, mobile }) =>
    !mobile &&
    isBulkBook &&
    css`
      width: ${disabled ? `calc(100% - ${theme.space.xxl} - ${theme.space.xxl})` : '100%'};
      font-size: 17px;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.94;
      letter-spacing: 0.6px;
      padding: ${theme.space.sm} ${!disabled ? 0 : theme.space.xxl} ${disabled ? theme.space.md : theme.space.xs};
    `}
`

export const BulkBookButton = styled.div`
  ${({ theme }) => css`
    font-size: 17px;
    display: block;
    text-align: center;

    .icon {
      display: inline;
      position: relative;
      top: 0.08em;
      margin-right: ${theme.space.xxs};

      svg {
        width: 16px;
        height: 16px;
      }
    }
  `}
`

export const ExpandBtn = styled.div`
  position: absolute;
  top: -16px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  width: 46px;
  justify-content: center;
  display: flex;
  background-color: white;
  cursor: pointer;
  ${({ theme }) => css`
    border-radius: ${theme.radius.md};

    span {
      font-size: 20px;
      color: ${theme.colors.brandSupporting01};
    }
  `}
`

export const ShadowExpand = styled(ExpandBtn as any)`
  height: 14px;
  box-shadow: 0 0 6px 0 rgb(0 0 0 / 50%);
`

export const StyledBtn = styled(Button)`
  ${({ theme, disabled }) => css`
    margin-left: auto;
    background-color: ${theme.colors.brandPrimaryContrast};
    box-shadow: inset 0 0 0 2px ${disabled ? theme.palette.gray100 : theme.colors.brandPrimary};
    padding: ${theme.space.xxs + ' ' + theme.space.sm};
    & > span > div {
      color: ${disabled ? theme.palette.gray100 : theme.colors.brandPrimary};
    }
  `}
`

export const LessonWrapper = styled.div<{ mobile?: boolean }>`
  ${getScollerCSS({
    border: '1px solid #cacaca',
    bgColor: '#cacaca',
  })}
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  padding-right: 3px;
  flex-grow: 1;
  ${({ theme, mobile }) => css`
    max-height: ${mobile ? '335px' : '515px'};
    margin-top: ${theme.space.sm};
  `}
`

export const LessonSelected = styled.div<{ isGroupLead?: boolean; isMobile?: boolean }>`
  ${({ theme, isGroupLead, isMobile }) => css`
    padding: ${theme.space.sm} ${isGroupLead && !isMobile ? theme.space.sm : theme.space.lg};
    background-color: ${theme.palette.info20};
    font-size: ${theme.fontSize.xxs};
    line-height: 1.14;
    letter-spacing: 0.49px;
    text-align: ${isGroupLead && !isMobile ? 'left' : 'center'};
    display: flex;
    align-items: ${isGroupLead && !isMobile ? 'center' : 'center'};
    justify-content: ${isGroupLead && !isMobile ? 'space-between' : 'center'};
    margin-bottom: ${theme.space.xs};

    .count-label {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      text-align: left;
    }

    button {
      padding: 6px;
      display: flex;
      align-items: center;
      margin-left: ${isMobile ? theme.space.sm : '0px'};
    }
  `}
`

export const LessonSelectedCount = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.brandPrimary};
    font-weight: ${theme.fontWeight.bold};
  `}
`

export const AlertWrapper = styled.div`
  ${({ theme }) => `
    padding-bottom: ${theme.space.xs};
    line-height: 1.38;
    letter-spacing: 0.56px;
    display: flex;
    & > div {
      display: block;
      padding: 10px 12px;
    }
    & > div > span > div {
      display: flex;
      align-items: center;
      font-size: ${theme.fontSize.xxs};
      padding-left: 8px;
    }

    svg {
      font-size: ${theme.fontSize.md};
      margin-top: 1px;
    }
  `}
`

export const TimeWrapper = styled.div`
  ${({ theme }) => `
    padding: 11px 0;
    background-color: ${theme.palette.blue10};
    border-radius: 2px;
    text-align: center;
    width: 100%;
    float: none;
    display: flex;
    justify-content: center;
    align-items: center;

    > * {
       width: max-content;
    }
  `}
`

export const InstructorSessions = styled.div`
  margin-bottom: 24px;
`

export const InstructorName = styled.div<{ isActive?: boolean }>`
  ${({ theme, isActive }) => css`
    background-color: ${isActive ? theme.colors.brandPrimary : theme.palette.info100};
    border-radius: 10px;
    padding: 2px 10px 3px;
    font-size: ${theme.fontSize.xxxs};
    font-weight: ${theme.fontWeight.bold};
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.42px;
    text-align: center;
    color: ${theme.palette.white};
    width: max-content;
    margin-bottom: 8px;
  `}
`

export const NoLessonsSelected = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.palette.gray100};
    display: flex;
    align-items: center;
    padding: 7px 17px 6px 7.5px;
    border-radius: 2px;
    color: ${theme.palette.charcoal};
    font-size: ${theme.fontSize.xxs};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: 0.49px;

    .icon {
      margin-right: 8.5px;

      svg {
        color: ${theme.palette.gray100};
      }
    }
  `}
`

export const BookedLessonCardWrapper = styled.div`
  ${() => css`
    margin-bottom: 11px;

    &:last-child {
      margin-bottom: 0px;
    }
  `}
`
